export default "__VITE_ASSET__BORaK_4V__"